import {
  SET_LOADING_STATUS,
  SetLoadingStatusAction,
  CHECK_MT_SERVERS_UPDATE,
  SET_LOADING_STATUS_DOWNLOAD,
  SET_LOADING_STATUS_CONNECTED_INVESTORS,
  SET_LOADING_STATUS_BALANCE_OPERATIONS,
  SET_LOADING_STATUS_CLOSED_ORDERS,
  SET_LOADING_STATUS_OPEN_ORDERS,
  SET_LOADING_STATUS_INVESTORS_FETCH,
  SET_LOADING_STATUS_MASTER_FETCH,
  SET_LOADING_STATUS_MASTERS_FETCH,
  SET_LOADING_STATUS_SUMMARY_PROFIT_FETCH
} from '../actions/setLoadingStatus';

export interface LoadingStatusState {
  isLoading: boolean;
  isLoadingDownload: boolean;
  checkMtServers: boolean;
  isLoadingOpenOrders: boolean;
  isLoadingClosedOrders: boolean;
  isLoadingBalanceOperations: boolean;
  isLoadingConnectedInvestors: boolean;
  isLoadingInvestorsFetch: boolean;
  isLoadingMasterFetch: boolean;
  isLoadingMastersFetch: boolean;
  isLoadingSummaryProfitFetch: boolean;
}

const initialState: LoadingStatusState = {
  isLoading: false,
  isLoadingDownload: false,
  checkMtServers: false,
  isLoadingOpenOrders: false,
  isLoadingClosedOrders: false,
  isLoadingBalanceOperations: false,
  isLoadingConnectedInvestors: false,
  isLoadingInvestorsFetch: false,
  isLoadingMasterFetch: false,
  isLoadingMastersFetch: false,
  isLoadingSummaryProfitFetch: false
};

function loadingStatusReducer(state: LoadingStatusState = initialState, action: SetLoadingStatusAction): LoadingStatusState {
  switch (action.type) {
    case SET_LOADING_STATUS: {
      return {
        ...state,
        isLoading: action.status
      };
    }

    case SET_LOADING_STATUS_DOWNLOAD: {
      return {
        ...state,
        isLoadingDownload: action.status
      };
    }
    case CHECK_MT_SERVERS_UPDATE: {
      return {
        ...state,
        checkMtServers: action.status
      };
    }
    case SET_LOADING_STATUS_OPEN_ORDERS: {
      return {
        ...state,
        isLoadingOpenOrders: action.status
      };
    }
    case SET_LOADING_STATUS_CLOSED_ORDERS: {
      return {
        ...state,
        isLoadingClosedOrders: action.status
      };
    }
    case SET_LOADING_STATUS_BALANCE_OPERATIONS: {
      return {
        ...state,
        isLoadingBalanceOperations: action.status
      };
    }
    case SET_LOADING_STATUS_CONNECTED_INVESTORS: {
      return {
        ...state,
        isLoadingConnectedInvestors: action.status
      };
    }
    case SET_LOADING_STATUS_INVESTORS_FETCH: {
      return {
        ...state,
        isLoadingInvestorsFetch: action.status
      };
    }
    case SET_LOADING_STATUS_MASTER_FETCH: {
      return {
        ...state,
        isLoadingMasterFetch: action.status
      };
    }
    case SET_LOADING_STATUS_MASTERS_FETCH: {
      return {
        ...state,
        isLoadingMastersFetch: action.status
      };
    }
    case SET_LOADING_STATUS_SUMMARY_PROFIT_FETCH: {
      return {
        ...state,
        isLoadingSummaryProfitFetch: action.status
      };
    }
    default: {
      return state;
    }
  }
}

export default loadingStatusReducer;
